export default __webpack_public_path__ + "static/media/crittercism.7538a2ce.svg";